/**
 * Tombol wishlist di kartu produk (.ss-product-wishlist) cuma menampilkan
 * icon hati (teks disembunyikan lewat CSS). Saat produk berhasil ditambahkan,
 * backend wishlist yang aktif (lihat includes/woocommerce/wishlist.php) cuma
 * menambah class ke tombolnya lewat JS-nya sendiri - WishSuite pakai
 * "added"/"wishsuite-btn-exist" (wishsuite/assets/js/frontend.js), LarisManis
 * pakai "lt-wc-wishlist-active" (larismanis-wp/assets/js/laristurbo-wc.min.js)
 * - jadi status "berhasil" dipantau di sini lewat MutationObserver, lalu teks
 * tombolnya di-flash sebentar sebagai tooltip di bawah icon.
 */

var TOOLTIP_VISIBLE_DURATION = 2000;
var BUTTON_SELECTOR = ".wishsuite-button, .lt-wc-wishlist-btn";
var TEXT_SELECTOR = ".wishsuite-btn-text, .lt-wc-wishlist-text";

function isAddedState(button) {
  return (
    button.classList.contains("added") ||
    button.classList.contains("wishsuite-btn-exist") ||
    button.classList.contains("lt-wc-wishlist-active")
  );
}

export function initWishlistTooltip(root) {
  // root dilewatkan lagi (mis. dari trending-tabs.js) tiap kali kartu produk
  // baru disuntikkan lewat AJAX (innerHTML), karena observer di bawah cuma
  // ke-attach ke tombol yang sudah ada di DOM saat fungsi ini dipanggil.
  var scope = root || document;
  var wrappers = scope.querySelectorAll(".ss-product-wishlist");
  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var button = wrapper.querySelector(BUTTON_SELECTOR);
    var tooltip = wrapper.querySelector(".ss-product-wishlist-tooltip");
    if (!button || !tooltip) return;

    var hideTimer = null;
    var wasAdded = isAddedState(button);

    function flashTooltip() {
      var textEl = button.querySelector(TEXT_SELECTOR);
      tooltip.textContent = textEl ? textEl.textContent : "";
      tooltip.classList.add("is-visible");

      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        tooltip.classList.remove("is-visible");
      }, TOOLTIP_VISIBLE_DURATION);
    }

    var observer = new MutationObserver(function () {
      var nowAdded = isAddedState(button);
      if (nowAdded && !wasAdded) {
        flashTooltip();
      }
      wasAdded = nowAdded;
    });

    observer.observe(button, { attributes: true, attributeFilter: ["class"] });
  });
}
